import {useEffect, useRef} from "react";
import {
    SHOW,
    useSearchResultDetailsDispatch,
    useSearchResultDetailsState,
} from "../search-result-details/SearchResultDetailsContext";

/**
 * Shows one document in the details view on its own (DE-1719: no previous/next from a search), once it has loaded,
 * and calls onClosed when the user closes the view. Used by the /documents route and by the document links' dialog.
 * Needs a SearchResultDetailsProvider.
 * @param {?Object} document - The loaded document, or nothing yet.
 * @param {function()} onClosed
 */
export const useStandaloneDetails = (document, onClosed) => {
    const dispatch = useSearchResultDetailsDispatch();
    const {selectedId} = useSearchResultDetailsState();
    const opened = useRef(false);

    useEffect(() => {
        if (document) {
            dispatch({type: SHOW, model: document, standalone: true});
        }
    }, [document, dispatch]);

    useEffect(() => {
        if (selectedId) {
            opened.current = true;
        } else if (opened.current) {
            opened.current = false;
            onClosed();
        }
    }, [selectedId, onClosed]);
};
